import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { BloomreachStockNotificationComponent } from '../../../../module/bloomreach/stock-notification/bloomreach-stock-notification.component';
import { NBackInStockModal } from './back-in-stock-modal.interface';

@DfModal({
    id: NBackInStockModal.ID,
    position: 'bottom',
    config: () => {
        return {
            minWidth: undefined,
            maxWidth: undefined,
            minHeight: '382px',
            width: '100%',
            position: {
                right: '0',
                bottom: '0',
                left: '0'
            },
            modalClass: 'bg-col-w p-l-0 p-r-0 p-b-0'
        };
    },
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'back-in-stock-modal',
    templateUrl: './back-in-stock-modal.component.html',
    standalone: true,
    imports: [CommonModule, BloomreachStockNotificationComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackInStockModalComponent {
    protected modalRef = inject(ModalRef);
    protected modalData = inject(MODAL_DATA);

    closeModal(): void {
        this.modalRef?.close();
    }
}
